export enum TaskStatus {
  TODO = 0,
  IN_PROGRESS = 1,
  UNDER_REVIEW = 2,
  COMPLETED = 3,
}

export const taskStatusOptions = Object.entries(TaskStatus)
  .filter(([, value]) => typeof value === 'number') // Exclude reverse mappings
  .map(([key, value]) => ({ label: key, value: value as number }));

export enum PriorityValues {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical',
}

export const PRIORITY_VALUES = [
  'Low',
  'Medium',
  'High',
  'Critical',
] as const;

export const PRIORITY_MAP: Array<{
  priority_code: number;
  name: PriorityValues;
  color: string;
}> = [
    {
      priority_code: 0,
      name: PriorityValues.LOW,
      color: 'bg-[color:#709FFF]',
    },
    {
      priority_code: 1,
      name: PriorityValues.MEDIUM,
      color: 'bg-[color:#F3E66D]',
    },
    {
      priority_code: 2,
      name: PriorityValues.HIGH,
      color: 'bg-[color:#FFB570]',
    },
    {
      priority_code: 3,
      name: PriorityValues.CRITICAL,
      color: 'bg-[color:#FF7070]',
    },
  ];

export const getPriorityName = (priority_code: number): PriorityValues | undefined => {
  const priority = PRIORITY_MAP.find(item => item.priority_code === priority_code);
  return priority?.name;
};

export function formatDateString(isoString: string): string {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return isoString;
  }
  return date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
